// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IndexPage.css */

.index-page {
  font-family: Arial, sans-serif;
  padding: 20px;
  text-align: center;
}

.index-page header {
  margin-bottom: 20px;
}

.index-page h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.index-page p {
  font-size: 1.2rem;
  color: #555;
}

/* Updated Search Bar Styling */
.search-bar.large {
  width: 60%; /* Increase width */
  padding: 15px; /* Add padding */
  font-size: 1.2rem; /* Increase font size */
  margin-bottom: 20px; /* Add margin below */
  border-radius: 8px; /* Rounded corners */
  border: 1px solid #ccc; /* Border styling */
}

/* Loading Screen Styling */
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Data Upload Button Styling */
.data-upload-buttons {
  margin-top: 30px;
}

.data-upload-buttons button {
  padding: 10px 20px;
  font-size: 1rem;
  margin: 0 10px;
  border-radius: 4px;
  background-color: #28a745;
  color: white;
  border: none;
  cursor: pointer;
}

.data-upload-buttons button:hover {
  background-color: #218838;
}

/* Table Styling */
.results-table {
  width: 80%;
  margin: 0 auto 20px auto; /* Center the table and add margin */
  border-collapse: collapse;
}

.results-table th,
.results-table td {
  border: 1px solid #dee2e6;
  padding: 12px 15px;
  text-align: left;
  font-size: 1rem;
}

.results-table th {
  background-color: #e9ecef;
  font-weight: bold;
}

.results-table tr:hover {
  background-color: #f1f3f5;
  cursor: pointer; /* Show pointer cursor on hover */
}

/* Style for clickable rows */
.clickable-row:hover {
  background-color: #dceefb; /* Lighter color on hover */
}

/* Footer Styling */
footer {
  margin-top: 40px;
  color: #777;
}`, "",{"version":3,"sources":["webpack://./src/IndexPage.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,UAAU,EAAE,mBAAmB;EAC/B,aAAa,EAAE,gBAAgB;EAC/B,iBAAiB,EAAE,uBAAuB;EAC1C,mBAAmB,EAAE,qBAAqB;EAC1C,kBAAkB,EAAE,oBAAoB;EACxC,sBAAsB,EAAE,mBAAmB;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,wBAAwB,EAAE,oCAAoC;EAC9D,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe,EAAE,iCAAiC;AACpD;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* IndexPage.css */\n\n.index-page {\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  text-align: center;\n}\n\n.index-page header {\n  margin-bottom: 20px;\n}\n\n.index-page h1 {\n  font-size: 2.5rem;\n  margin-bottom: 10px;\n}\n\n.index-page p {\n  font-size: 1.2rem;\n  color: #555;\n}\n\n/* Updated Search Bar Styling */\n.search-bar.large {\n  width: 60%; /* Increase width */\n  padding: 15px; /* Add padding */\n  font-size: 1.2rem; /* Increase font size */\n  margin-bottom: 20px; /* Add margin below */\n  border-radius: 8px; /* Rounded corners */\n  border: 1px solid #ccc; /* Border styling */\n}\n\n/* Loading Screen Styling */\n.loading-screen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  flex-direction: column;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Data Upload Button Styling */\n.data-upload-buttons {\n  margin-top: 30px;\n}\n\n.data-upload-buttons button {\n  padding: 10px 20px;\n  font-size: 1rem;\n  margin: 0 10px;\n  border-radius: 4px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.data-upload-buttons button:hover {\n  background-color: #218838;\n}\n\n/* Table Styling */\n.results-table {\n  width: 80%;\n  margin: 0 auto 20px auto; /* Center the table and add margin */\n  border-collapse: collapse;\n}\n\n.results-table th,\n.results-table td {\n  border: 1px solid #dee2e6;\n  padding: 12px 15px;\n  text-align: left;\n  font-size: 1rem;\n}\n\n.results-table th {\n  background-color: #e9ecef;\n  font-weight: bold;\n}\n\n.results-table tr:hover {\n  background-color: #f1f3f5;\n  cursor: pointer; /* Show pointer cursor on hover */\n}\n\n/* Style for clickable rows */\n.clickable-row:hover {\n  background-color: #dceefb; /* Lighter color on hover */\n}\n\n/* Footer Styling */\nfooter {\n  margin-top: 40px;\n  color: #777;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
